const styles = theme => ({
  root: {
    justifyContent: 'center'
  },

  title: {
    fontFamily: "'Montserrat', sans-serif",
    textAlign: 'center'
  },

  paper: {
    padding: 30,
    marginLeft: 10,
    marginRight: 10,
    marginBottom: 30
  },

  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120
  },

  inputRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 10
  },

  textFieldRoot: {
    padding: 0,
    marginLeft: 10,
    'label + &': {
      //marginTop: theme.spacing.unit * 3,
    }
  },

  confirmButtonContainer: {
    justifyContent: 'center',
    display: 'flex',
    marginTop: 20
  },

  termsContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 20
  },

  termsText: {
    maxWidth: 600,
    color: 'rgba(0,0,0,0.5)',
    fontSize: 14
  },

  confirmDonationButton: {},

  textFieldInput: {
    borderRadius: 4,
    //backgroundColor: theme.palette.common.white,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 12px',
    width: 'calc(100% - 24px)',
    //transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)'
    }
  },

  textFieldFormLabel: {
    fontSize: 18
  },

  selectInput: {
    width: '100%'
  },

  inputHalf: {
    display: 'flex',
    flex: 1
  }

  // inputHalf: {
  //   display: 'flex',
  //   flex: 1,
  //   justifyContent: 'flex-end'
  // },
});

export default styles;



// WEBPACK FOOTER //
// ./src/containers/add/styles.js